import React from 'react';

const Badge = ({
  children,
  variant = 'default', // default, success, warning, danger, info, secondary, outline
  className = ''
}) => {
  const variants = {
    default: 'bg-gray-700 text-gray-200 border-gray-600',
    success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
    danger: 'bg-red-500/10 text-red-400 border-red-500/20',
    info: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
    secondary: 'bg-gray-600 text-gray-300 border-gray-500',
    outline: 'bg-transparent text-gray-300 border-gray-600',
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
